import { css } from 'lit';

export default css`
  :host {
    display: block;
    font-family: var(--font-family-base, 'Inter, Arial, sans-serif');
    --pagination-gap: var(--spacing-xs, 8px);
    --item-size: 48px;
    --item-padding: var(--spacing-sm, 12px);
    --item-border-radius: 24px;
    --item-bg: transparent;
    --item-bg-hover: var(--surface-raised, var(--color-white, #ffffff));
    --item-bg-selected: var(--color-secondary, #2594e3);
    --item-border: none;
    --item-border-hover: var(--sm-line, 2px) solid var(--color-secondary, #2594e3);
    --item-color: var(--on-surface, var(--color-dark-gray, #1c2321));
    --item-color-selected: var(--color-white, #ffffff);
    --item-color-disabled: var(--color-gray-3, #d7d4d2);
  }

  .pagination {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 0;
    gap: var(--pagination-gap);
  }

  .page-item {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: var(--item-padding);
    width: var(--item-size);
    height: var(--item-size);
    border-radius: var(--item-border-radius);
    border: var(--item-border);
    background: var(--item-bg);
    font-size: var(--font-size-b1, 16px);
    line-height: var(--line-height-b1, 24px);
    font-weight: var(--font-weight-regular, 400);
    color: var(--item-color);
    cursor: pointer;
    transition: all var(--duration-base, 0.2s) var(--easing-ease, ease);
  }

  .page-item:hover:not(.disabled):not(.selected),
  .page-item.hover:not(.disabled):not(.selected) {
    background: var(--item-bg-hover);
    border: var(--item-border-hover);
  }

  .page-item:focus:not(.disabled):not(.selected),
  .page-item.focus:not(.disabled):not(.selected) {
    background: var(--item-bg-hover);
    border: var(--item-border-hover);
    box-shadow: var(--shadow-focus);
    color: var(--color-primary-dark, #001d68);
  }

  .page-item:focus-visible {
    outline: 2px solid var(--color-secondary, #2594e3);
    outline-offset: 2px;
  }

  .page-item.selected {
    background: var(--item-bg-selected);
    color: var(--item-color-selected);
  }

  .page-item.disabled {
    cursor: not-allowed;
    color: var(--item-color-disabled);
  }

  .page-item.ellipsis {
    cursor: default;
  }

  ::slotted([slot="prev-icon"]),
  ::slotted([slot="next-icon"]) {
    width: 24px;
    height: 24px;
    color: var(--item-color);
  }

  ::slotted([slot="prev-icon"]) {
    transform: translateX(-2px);
  }

  ::slotted([slot="next-icon"]) {
    transform: translateX(2px);
  }

  .page-item.selected ::slotted([slot="prev-icon"]),
  .page-item.selected ::slotted([slot="next-icon"]) {
    color: var(--item-color-selected);
  }

  .page-item.disabled ::slotted([slot="prev-icon"]),
  .page-item.disabled ::slotted([slot="next-icon"]) {
    color: var(--item-color-disabled);
  }

  .page-item.focus ::slotted([slot="prev-icon"]),
  .page-item.focus ::slotted([slot="next-icon"]),
  .page-item.hover ::slotted([slot="prev-icon"]),
  .page-item.hover ::slotted([slot="next-icon"]) {
    color: var(--color-primary-dark, #001d68);
  }

  ::slotted([slot^="page-"]) {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }

  @media (max-width: 768px) {
    .page-item {
      width: 40px;
      height: 40px;
      padding: var(--spacing-xs, 8px);
      font-size: var(--font-size-b3, 14px);
    }
  }
`;